import {TextCustom} from '@vw-marketing/us-components';
import React, {useEffect, useState} from 'react';
import {FilterDistanceConfig} from '../../typing/main';
import {FilterDistanceTranslation} from '../../typing/translations';
import FilterContentLabel from '../filter-content-label';
import {DistanceSlider} from './distance-slider';
import {labelDistanceTextStyle} from './helpers';
import {
  StyledFilterDistanceContainer,
  StyledFilterDistanceLabel,
  StyledFilterSliderContainer,
} from './styles';

interface FilterDistanceProps {
  config: FilterDistanceConfig;
  isMobile: boolean;
  onHandleDistanceChange: (distance: number | number[], type: string) => void;
  translation: FilterDistanceTranslation;
  userDistance: number;
}
const FilterDistance: React.FC<FilterDistanceProps> = ({
  config,
  isMobile,
  onHandleDistanceChange,
  translation,
  userDistance,
}) => {
  const [hideOptions, setHideOptions] = useState(false);
  const [distanceValue, setDistanceValue] = useState(userDistance);
  const formatDistanceNumber = (number: number) =>
    number.toLocaleString() + `${number === config.maxDistance ? '+' : ''}`;

  const onHandleSliderChangeCommitted = (
    _: React.ChangeEvent<{}>,
    value: number | number[],
  ) => {
    onHandleDistanceChange(value, 'distance');
  };

  const onHandleSliderChange = (
    _: React.ChangeEvent<{}>,
    value: number | number[],
  ) => {
    setDistanceValue(value as number);
  };

  useEffect(() => {
    setDistanceValue(userDistance);
  }, [userDistance]);

  return (
    <StyledFilterDistanceContainer className="filter-distance_container">
      <StyledFilterDistanceLabel className="filter-distance_label">
        <div className="filter-distance_mobile-label">
          <FilterContentLabel
            label={translation.label}
            hideOptions={hideOptions}
            setHideOptions={setHideOptions}
            isMobile={isMobile}
          />
        </div>
        <div className="filter-distance_desktop-label">
          <TextCustom {...labelDistanceTextStyle}>
            {translation.label}
          </TextCustom>
        </div>
      </StyledFilterDistanceLabel>
      {(hideOptions && isMobile) || !isMobile ? (
        <StyledFilterSliderContainer
          id="filter-select-distance"
          className="filter-distance_slider"
        >
          <DistanceSlider
            defaultValue={userDistance}
            value={distanceValue}
            aria-labelledby="filter-select-distance"
            step={null}
            marks={config.marksValues}
            min={config.minDistance - config.step}
            max={config.maxDistance + config.step}
            onChangeCommitted={onHandleSliderChangeCommitted}
            valueLabelFormat={formatDistanceNumber}
            valueLabelDisplay={config.markDisplay}
            onChange={onHandleSliderChange}
          />
        </StyledFilterSliderContainer>
      ) : null}
    </StyledFilterDistanceContainer>
  );
};

export default FilterDistance;
